import { NgModule, inject } from '@angular/core';
import { ActivatedRouteSnapshot, RouterModule } from '@angular/router';

import { RouteTag } from '@frontend/sports/common/core/data-access/route';

import { EmptyComponent } from '../common/empty.component';
import { nameIdentifierMatcher } from '../router/name-identifier.matcher';
import { use } from '../router/router.resolver';
import { SitemapRoutingToken } from '../sitemap/sitemap-routing';
import { EventDetailsBreadcrumbsResolver } from './event-details-breadcrumb.resolver';
import { EventDetailsModalGuard } from './event-details-modal.guard';
import { EventDetailsComponent } from './event-details.component';
import { EventDetailsGuard } from './event-details.guard';
import { EventDetailsResolver } from './event-details.resolver';
import { EventViewSubNavigationResolve } from './event-view-subnavigation.resolve';

const routes = [
    {
        path: '',
        canActivate: [EventDetailsGuard],
        component: EmptyComponent,
    },
    {
        matcher: nameIdentifierMatcher,
        component: EventDetailsComponent,
        canActivate: [EventDetailsModalGuard],
        resolve: use(EventDetailsResolver),
        data: {
            matcherParam: 'event',
            htmlClass: 'event-details-page',
            tag: RouteTag.EventDetails,
            breadcrumbs: EventDetailsBreadcrumbsResolver,
            subNavigation: EventViewSubNavigationResolve,
            sitemap: SitemapRoutingToken.EventDetailsSitemapResolver,
            shouldKeepBreadcrumbs: true,
            preResolve: (route: ActivatedRouteSnapshot) => {
                inject(EventDetailsResolver).preResolve(route);
            },
        },
    },
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule],
})
export class EventDetailsRoutingModule {}
